import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { isChunkLoadError } from '../../Utils/lazyWithRetry';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Erreur interceptée par ErrorBoundary :', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    const chunkError = isChunkLoadError(error);
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        gap={2}
        p={2}
        textAlign="center"
      >
        <Typography variant="h5">
          {chunkError ? 'Une nouvelle version est disponible' : 'Une erreur est survenue'}
        </Typography>
        <Typography color="text.secondary">
          {chunkError
            ? "Impossible de charger une partie de l'application. Veuillez recharger la page."
            : 'Veuillez recharger la page. Si le problème persiste, contactez le support.'}
        </Typography>
        <Button variant="contained" onClick={this.handleReload}>
          Recharger la page
        </Button>
      </Box>
    );
  }
}

export default ErrorBoundary;
